import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamSSDInterface,
  fetchProcessorSSDInterface,
  fetchProcessorSSDInterfaceById,
  updateProcessorSSDInterface,
  updateStatusInProcessorSSDInterface,
} from "./thunk";

interface CategoryState {
  processor_ssd_interface_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ssd_interface_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "ssd_interface",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorSSDInterface.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSSDInterface.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ssd_interface_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorSSDInterface.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorSSDInterfaceById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSSDInterfaceById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorSSDInterfaceById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamSSDInterface.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ssd_interface_list = state.processor_ssd_interface_list.map((ssd_interface) =>
          ssd_interface.id === action.payload.id ? action.payload : ssd_interface
        );
      })
      .addCase(addProcessorRamSSDInterface.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      
      
    
      .addCase(updateStatusInProcessorSSDInterface.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
